import React, { useRef } from "react";
import Link from "next/link";
import Image from "next/image";
import Button from "@/components/ui/button";
import Title from "@/components/ui/Title";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

type Props = {};

const tourimg = [
  {
    img: "/tour/bhutan1.jpg",
  },
  {
    img: "/tour/bhutan2.jpg",
  },
  {
    img: "/tour/bhutan4.jpg",
  },
  {
    img: "/tour/bhutan3.jpg",
  },
];
export default function ServicesHome({}: Props) {
  const maincontainer = useRef<any>();
  const animatepackage = useRef<any>();

  // useGSAP(() => {
  //   const tl = gsap.timeline({
  //     scrollTrigger: {
  //       trigger: maincontainer.current,
  //       start: "top bottom",
  //       end: "bottom top",
  //       scrub: true,
  //       markers: true,
  //     },
  //   });

  //   // Animation for scaling in
  //   tl.from(maincontainer.current, { scale: 0.2 });

  //   // Animation for scaling out when scrolling back
  //   tl.to(maincontainer.current, {
  //     scale: 0.5,
  //     // Add any other properties you want to animate here
  //   });
  // });
  return (
    <main ref={maincontainer}>
      <div className="mx-auto lg:my-20 md:my-12 my-8 flex justify-center items-center  lg:w-11/12 w-11/12 3xl:w-8/12  relative">
        {/* Tour Section */}
        <div
          className="grid md:grid-cols-2 gap-y-4 place-items-center"
          ref={animatepackage}
        >
          <div className="flex flex-col home-about-title justify-between gap-2">
            <div className="md:w-[90%] flex-col flex gap-2 justify-start items-start">
              <h2 className="uppercase font-extrabold title lg:text-[2.2em] leading-[1em] sm:text-[1.5em] text-2xl">
                Bhutan Trip
              </h2>

              <p className="md:text-base text-sm desc text-zinc-700 my-4">
                Embark on a journey to explore the world’s most stunning travel
                destinations with our handpicked, expertly curated tours.
                Whether you are after thrilling adventures in untamed
                landscapes, cultural experiences in iconic cities, or serene
                escapes in tranquil environments, we offer tailor-made
                experiences that cater to your desires. From scaling mountains
                to unwinding on pristine beaches, environments, we offer
                tailor-made experiences that cater to your desires. From scaling
                mountains to unwinding on pristine beaches, our tours ensure
                that every traveler finds their perfect getaway. Let us turn
                your travel dreams into unforgettable memories with our seamless
                planning and personalized itineraries designed to fit your pace
                and preferences. desires.
              </p>
            </div>

            <Link href="/other_activities/bhutan-tours">
              <div className="text-white">
                <Button> Know More</Button>
              </div>
            </Link>
          </div>

          <div className="grid grid-cols-2 gap-4">
            {tourimg.map((item, index) => (
              <div key={index}>
                <Image
                  src={item.img}
                  alt="tour-img"
                  width={1000}
                  height={1000}
                  className="w-[20em] h-[25vh] object-cover rounded-md"
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* <div className="bg-parallax3 bg-fixed bg-cover bg-black bg-opacity-50 bg-blend-overlay lg:h-[70vh] md:h-[60vh] h-[50vh] relative">
        <h2 className="title uppercase text-white lg:text-[3.5vw] font-extrabold md:text-5xl text-5xl text-center lg:whitespace-nowrap absolute left-1/2 -translate-y-1/2 top-1/2 -translate-x-1/2">
          Create your memories once in a lifetime
        </h2>
      </div> */}

      {/* Schooling Group Section */}
      <div
        className="lg:w-11/12 w-11/12 3xl:w-8/12 mx-auto grid md:grid-cols-2 place-items-center  gap-8"
        ref={animatepackage}
      >
        <figure className="h-[50vh] order-2 md:order-1 ">
          <Image
            src="/group.jpeg"
            alt="school"
            height={1000}
            width={1000}
            className="rounded-md h-full object-cover"
          />
        </figure>

        <div className="flex flex-col space-y-2  order-1 md:order-2">
          <div className="md:w-[90%] flex-col flex  justify-start items-start">
            {/* <h1 className="lg:text-[3vw] text-2xl leading-none title tracking-wider  uppercase text-secondary-500 relative text-center font-bold">
              Schooling Group
              <hr className="bg-orange-300 h-[4px] overflow-hidden w-[70%]" />
            </h1> */}
            <h2 className="uppercase font-extrabold title lg:text-[2.2em] leading-[1em] sm:text-[1.5em] text-2xl">
              Schooling Group
            </h2>

            <p className="text-zinc-700 desc md:text-base text-sm my-5">
              Discover our specialized group tours designed exclusively for
              students and educators, blending education with adventure in an
              unforgettable experience. These meticulously crafted journeys
              offer a unique balance between cultural immersion and hands-on
              learning, making each destination a living classroom. Whether
              exploring ancient historical landmarks, engaging in environmental
              studies, or diving into the arts and sciences of different
              cultures, our tours provide valuable educational opportunities.
              Educators and students alike will experience meaningful growth
              through real-world exploration, gaining new perspectives while
              fostering curiosity and a love for learning. Educators and
              students alike will experience meaningful growth through
              real-world exploration
            </p>
          </div>

          <Link href="/contact_us">
            <div className="text-white">
              <Button> Know More</Button>
            </div>
          </Link>
        </div>
      </div>

      {/* Family Tour Section*/}
      <div
        className="lg:w-11/12 w-11/12 3xl:w-8/12 mx-auto md:my-12 my-8  grid md:grid-cols-2 place-items-center  gap-8"
        ref={animatepackage}
      >
        <div className="flex flex-col space-y-2">
          <div className="md:w-[90%] flex-col flex  justify-start items-start">
            <h2 className="uppercase font-extrabold title lg:text-[2.2em] leading-[1em] sm:text-[1.5em] text-2xl">
              Family Tour
            </h2>

            <p className="text-zinc-700 desc md:text-base text-sm my-5">
              Discover our specialized group tours designed exclusively for
              students and educators, blending education with adventure in an
              unforgettable experience. These meticulously crafted journeys
              offer a unique balance between cultural immersion and hands-on
              learning, making each destination a living classroom. Whether
              exploring ancient historical landmarks, engaging in environmental
              studies, or diving into the arts and sciences of different
              cultures, our tours provide valuable educational opportunities.
              Educators and students alike will experience meaningful growth
              through real-world exploration, gaining new perspectives while
              fostering curiosity and a love for learning. Educators and
              students alike will experience meaningful growth through
              real-world exploration
            </p>
          </div>

          <Link href="/contact_us">
            <div className="text-white ">
              <Button> Know More</Button>
            </div>
          </Link>
        </div>

        <figure className="h-[50vh] ">
          <Image
            src="/familytrip.avif"
            alt="school"
            height={1000}
            width={1000}
            className="rounded-md h-full object-cover"
          />
        </figure>
      </div>
    </main>
  );
}
